import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import KierowcaLogiTab from "./kierowcyTab/KierowcaLogiTab";
import EbusLogiTab from "./ebusTab/EbusLogiTab";

export default class LogiContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
    }

    componentDidMount() {
    }

    renderContent() {
        if (this.state.activeTab === 1) {
            return <KierowcaLogiTab/>
        }
        else if (this.state.activeTab === 2) {
            return <EbusLogiTab/>
        }
        else if (this.state.activeTab === 3) {
            return <span>logi client app</span>
        }
    }

    changeActiveTab(eventKey){
        this.setState({activeTab:eventKey})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'SzablonyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/logi',
                                    text: 'Przeglądarka logów'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="rozklad-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="TOP eBus DRIVER" >
                                </Tab>
                                <Tab eventKey={2} title="TOP eBus & Strona">
                                </Tab>
                                <Tab eventKey={3} title="EBUS Client Mobile">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop:'15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/logi/LogiContainer.js